// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-47921338]{position:absolute;list-style-type:none;background-color:hsla(0,0%,100%,.97);border:1px solid #ededed;border-top:0;margin:0 auto;padding:0;z-index:100}li[data-v-47921338]{text-align:left}li>a[data-v-47921338]{display:block;padding:17px 30px}li>a[data-v-47921338]:hover{background-color:#ededed}", ""]);
// Exports
module.exports = exports;
